import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { prepLink } from 'src/utils/linkUtils';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import SocialButton from 'src/components/buttons/socialButton';
import Button from 'src/components/buttons/button';
import Card from 'src/components/card';
import { Disclaimer } from 'src/components/sidebar/disclaimer';
export default function SideContent() {
  return <>
      <Contact data-sentry-element="Contact" data-sentry-source-file="sideContent.tsx" />
      <Support data-sentry-element="Support" data-sentry-source-file="sideContent.tsx" />
      <Card data-sentry-element="Card" data-sentry-source-file="sideContent.tsx">
        <Disclaimer data-sentry-element="Disclaimer" data-sentry-source-file="sideContent.tsx" />
      </Card>
    </>;
}
function Contact() {
  const {
    contact
  } = useSelector(({
    pages
  }) => pages.communityAbout);
  if (!contact) return null;
  const {
    website,
    contactNumber,
    facebookPage,
    twitterHandle,
    instagramUsername,
    youtubePage
  } = contact;
  return <Card title={i18n.t('Contact')} data-sentry-element="Card" data-sentry-component="Contact" data-sentry-source-file="sideContent.tsx">
      {website && <WebsiteLink href={prepLink(website)} rel="noreferrer" target="_blank" onClick={() => {
      trackFootfallEvent(Event.Clicked, {
        clickType: 'community-website',
        clickMetadata: {
          section: Section.CommunityAbout
        }
      });
    }}>
          {website}
        </WebsiteLink>}
      {contactNumber && <Text>{contactNumber}</Text>}
      <div>
        {facebookPage && <a href={prepLink(facebookPage)} rel="noreferrer" target="_blank">
            <SocialButton brand="facebook" />
          </a>}
        {twitterHandle && <a href={`https://twitter.com/${twitterHandle}`} rel="noreferrer" target="_blank">
            <SocialButton brand="twitter" />
          </a>}
        {instagramUsername && <a href={`https://instagram.com/${instagramUsername}`} rel="noreferrer" target="_blank">
            <SocialButton brand="instagram" />
          </a>}
        {youtubePage && <a href={prepLink(youtubePage)} rel="noreferrer" target="_blank">
            <SocialButton brand="youtube" />
          </a>}
      </div>
    </Card>;
}
function Support() {
  const {
    support
  } = useSelector(({
    pages
  }) => pages.communityAbout);
  if (!support) return null;
  const {
    supportBoxHeading,
    supportBoxBody,
    supportButtonText,
    supportLink
  } = support;
  return <Card title={supportBoxHeading || i18n.t('Support us')} data-sentry-element="Card" data-sentry-component="Support" data-sentry-source-file="sideContent.tsx">
      {supportBoxBody && <Text>{supportBoxBody}</Text>}
      {supportLink && <a href={prepLink(supportLink)} rel="noreferrer" target="_blank">
          <SupportButton text={supportButtonText || i18n.t('Donate')} type="secondary" />
        </a>}
    </Card>;
}
const WebsiteLink = styled.a`
  display: inline-block;
  margin-bottom: 10px;
`;
const Text = styled.p`
  margin-bottom: 10px;
`;
const SupportButton = styled(Button)`
  font-size: ${({
  theme
}) => theme.fontSizeXs};
`;